import { useCallback, useEffect, useRef, useState } from "react"

const useGetColumnMap = (key: string) => {
  const [hiddenColumns, setHiddenColumns] = useState<any>([])
  const columnsRef = useRef(null)

  // update the hidden columns state when key is available
  useEffect(() => {
    const columnMap: any = localStorage.getItem("columnMap")
    if (columnMap) setHiddenColumns(JSON.parse(columnMap)?.[key] || [])
  }, [])

  // update the localStorage with the hidden columns
  const updateLocalStorage = useCallback(() => {
    const columnMap: any = localStorage.getItem("columnMap") || "{}"
    const data = { ...JSON.parse(columnMap), [key]: columnsRef.current }
    localStorage.setItem("columnMap", JSON.stringify(data))
  }, [])

  // update the columns selection with ref to persist between renders
  const handleColumnSelection = useCallback((columns: any) => {
    columnsRef.current = columns
  },[])

  return [hiddenColumns, updateLocalStorage, handleColumnSelection]
}

export default useGetColumnMap
